module.exports = __webpack_public_path__ + "media/flags/es-7ab20088.png";